import React from 'react';
import PropTypes from 'prop-types';
import { MosaicWall, TextMosaic, TextMosaicDto } from '@ami/react/core';
import { WeightCategory } from '../../products/productConfiguration';
import { makeConcealable } from '@ami/react/core';
import _ from 'lodash';
import LeadTimeWarnings from '../../quotes/LeadTimeWarnings';

class CreateQuoteWeightClass extends React.PureComponent {
  static propTypes = {
    weightCategoryId: PropTypes.string,
    onUpdate: PropTypes.func.isRequired,
    weightCategories: PropTypes.arrayOf(PropTypes.instanceOf(WeightCategory))
      .isRequired,
    title: PropTypes.string,
  };

  sort = (items) => _.sortBy(items, (x) => x.name);

  mapToMosaicDto = (selectedWeightCategoryId) => (weightCategories) =>
    weightCategories.map(
      (x) =>
        new TextMosaicDto({
          id: x.id,
          label: x.name,
          description: x.description,
          selected: x.id === selectedWeightCategoryId,
        })
    );

  render() {
    const { weightCategories, title } = this.props;
    const invalid = !this.props.weightCategoryId;
    return (
      <React.Fragment>
        <MosaicWall
          placeholder="Please select a weight category"
          childrenContainerClassName={`row justify-content-center ${
            invalid && 'invalid'
          }`}
          title={title}
        >
          {_.flowRight(
            this.sort,
            this.mapToMosaicDto(this.props.weightCategoryId)
          )(this.props.weightCategories).map((x) => (
            <TextMosaic
              key={x.id}
              data={x}
              onClick={(weightCategoryId) =>
                this.props.onUpdate({
                  weightCategoryId,
                  weightCategoryLabel: weightCategories.find(
                    (x) => x.id === weightCategoryId
                  ).label,
                  weightCategoryDescription: weightCategories.find(
                    (x) => x.id === weightCategoryId
                  ).description,
                })
              }
            />
          ))}
        </MosaicWall>
        <LeadTimeWarnings machineMissing={true} couplerMissing={false} />
      </React.Fragment>
    );
  }
}

export default makeConcealable(CreateQuoteWeightClass);
